import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { } from 'components'
import { Row, Col } from 'reactstrap'
import { } from "phosphor-react"
import SearchItem from '../../components/Search/SearchItem'

class SearchItems extends React.Component {
    render() {
        return (
            <Row className="search-items w-100 mx-0">
                <Col md={12} lg={12} className="search-title xl-font-size">
                    {this.props.title}
                </Col>
                <Row className="w-100 mx-0">
                    {
                        this.props.items.map((item, index) => (
                            <SearchItem key={index}
                                href={this.props.title}
                                title={item.title}
                                id={item.id}
                                image={item.image}
                                desc={item.desc}
                                props={this.props.props}
                            />
                        ))
                    }
                </Row>
            </Row>
        )
    }
}

SearchItems.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array,
    props: PropTypes.object,
}

export default withTranslation()(SearchItems)





// WEBPACK FOOTER //
// ./src/components/Search/SearchItems.jsx